import React from 'react';
import { cn } from './cn';

export interface SkeletonProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Tailwind width/height class. */
  width?: string;
  height?: string;
  shape?: 'rect' | 'circle' | 'pill';
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = 'w-full', height = 'h-4', shape = 'rect', className, ...rest
}) => (
  <span
    className={cn(
      'inline-block skeleton-shimmer',
      width, height,
      shape === 'circle' ? 'rounded-full'
        : shape === 'pill' ? 'rounded-full'
          : 'rounded-md',
      className,
    )}
    aria-hidden
    {...rest}
  />
);

export const SkeletonText: React.FC<{ lines?: number; className?: string }> = ({
  lines = 3, className,
}) => (
  <div className={cn('space-y-2', className)}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        height="h-3"
        width={i === lines - 1 ? 'w-3/5' : 'w-full'}
      />
    ))}
  </div>
);
